// Prefixo /admin: o Dashboard só monta as rotas do painel dentro de /admin/*.
export const ROTA_FORMAS = "/admin/financeiro/formas-pagamento";
export const ROTA_NOVA_FORMA = `${ROTA_FORMAS}/nova`;
export const rotaEditarForma = (id) => `${ROTA_FORMAS}/${id}/editar`;
export const rotaEditarCanal = (chave) => `${ROTA_FORMAS}/canal/${chave}`;
